import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import { ExcelRenderer } from 'react-excel-renderer';
import TableSearchwithStudentResult from "../questioners/manage_questin_papers/TableSearchwithStudentResult";
import SampleExcel from '../../../images/Studentssample.xls';
import './_educationManagementStudents.scss';


const ADD_STUDENT = gql`
  mutation($params: EduStudentInput) {
    AddEducationalStudents(params: $params)
  }
`;

class StudentModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentStep: 1,
            branch: "",
            section: "",
            class: "",
            exam: "",
            defaultvalue: 0,
            cols: [],
            rows: [],
            StudentsFilterData: [],
            classError: "",
            branchError: "",
            examError: "",
            sectionError: "",
            fileError: "",
            dataClear: 0,
            submitError: "",
            loadingSpinner: 0,
            isSubmitting: false,
            getExams: [],
            getClasses: [],
            getSections: [],
        };
    };

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                dataClear: 1,
                StudentsFilterData: [],
                rows: [],
                section: "",
                class: "",
                exam: "",
                classError: "",
                examError: "",
                sectionError: "",
                fileError: "",
                submitError: "",
                branch: "",
                branchError: "",
                isSubmitting: false,
                getExams: [],
                getClasses: [],
                getSections: [],
            })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    };

    handleFileChange = e => {
        this.setState({
            StudentsFilterData: [],
            cols: []
        });
        let fileObj = e.target.files[0];
        let fileType = ['application/vnd.ms-excel'];

        if (!fileType.includes(fileObj.type)) {
            this.setState({
                fileError: "Ivalid Format"
            });
            return ""
        }

        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {
            console.log("res", resp);
            if (err) {
                console.log(err);
            }
            else {
                let studentData = []
                if (resp.rows) {
                    let rowData = resp.rows.slice(1);
                    if (rowData) {
                        rowData.map(item => {
                            if (item[0] != undefined && item[1] != undefined && item[2] != undefined && item[3] != undefined && item[4] != undefined && item[5] != undefined && item[6] != undefined) {
                                studentData.push({ student_roll_no: item[1].toString(), student_name: item[2].toString(), student_mobile: item[3].toString(), parent_name: item[4].toString(), parent_mobile: item[5].toString(), parent_password: item[6].toString() })
                            }
                        });
                    }
                }
                this.setState({
                    StudentsFilterData: studentData,
                    fileError: ""
                });
            }
        });

    };

    handleInputChange = e => {

        const name = e.target.name;
        const value = e.target.value;

        let getArray = [];

        if (name == "branch") {
            if (value != "0") {

                let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();

                uniqueExams.map((val) => {
                    let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualExamData.id,
                        label: individualExamData.exam
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    branch: value,
                    branchError: "",
                    exam: "",
                    examError: "",
                    class: "",
                    classError: "",
                    section: "",
                    sectionError: "",
                    getExams: getArray,
                    getClasses: [],
                    getSections: [],
                    submitError: ""
                })

            } else {

                this.setState({
                    branch: "",
                    branchError: "",
                    exam: "",
                    examError: "",
                    class: "",
                    classError: "",
                    section: "",
                    sectionError: "",
                    getExams: [],
                    getClasses: [],
                    getSections: [],
                    submitError: ""
                })
            }
        }

        if (name == "exam") {

            if (value != "0") {


                let uniqueClasses = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branch && item.exam_id == value).map((item1) => item1.class_id))].sort();

                uniqueClasses.map((val) => {
                    let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualClassData.id,
                        label: individualClassData.class
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    branchError: "",
                    exam: value,
                    examError: "",
                    class: "",
                    classError: "",
                    section: "",
                    sectionError: "",
                    getClasses: getArray,
                    getSections: [],
                    submitError: ""
                })
            } else {
                this.setState({
                    branchError: "",
                    exam: "",
                    examError: "",
                    class: "",
                    classError: "",
                    section: "",
                    sectionError: "",
                    getClasses: [],
                    getSections: [],
                    submitError: ""
                })

            }
        }


        if (name == "class") {

            if (value != "0") {

                let uniqueSections = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branch && item.exam_id == this.state.exam && item.class_id == value).map((item1) => item1.section_id))].sort();

                uniqueSections.map((val) => {
                    let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualSectionData.id,
                        label: individualSectionData.section_name
                    }
                    getArray.push(newObj);
                })

                let sections = getArray.map((item) => item.value).toString();

                this.setState({
                    branchError: "",
                    examError: "",
                    class: value,
                    classError: "",
                    section: "",
                    sectionError: "",
                    getSections: getArray,
                    submitError: ""
                })

            } else {

                this.setState({
                    branchError: "",
                    examError: "",
                    class: "",
                    classError: "",
                    section: "",
                    sectionError: "",
                    getSections: [],
                    submitError: ""
                })

            }

        }


        if (name == "section") {
            if (value != "0") {
                this.setState({
                    section: value,
                    sectionError: "",
                    submitError: ""
                })
            } else {
                this.setState({
                    section: "",
                    sectionError: "",
                    submitError: ""
                })
            }
        }

    };

    handleFormSubmit = e => {
        console.log("wwwwwwww", e);
        if (this.state.branch == "") {
            this.setState({ branchError: "Please select branch" })
            return ""
        }
        if (this.state.exam == "") {
            this.setState({ examError: "Please select exam" })
            return ""
        }
        if (this.state.class == "") {
            this.setState({ classError: "Please select class" })
            return ""
        }
        if (this.state.section == "") {
            this.setState({ sectionError: "Please select section" })
            return ""
        }

        if (!this.state.StudentsFilterData.length) {
            this.setState({ fileError: "Upload file" });
            return ""
        }


        e.preventDefault();
        this.setState({ isSubmitting: true })

        let params = {
            branch_id: parseInt(this.state.branch),
            section_id: parseInt(this.state.section),
            class_id: parseInt(this.state.class),
            exam_id: parseInt(this.state.exam),
            institute_id: parseInt(Cookies.get("institutionid")),
            student_details: this.state.StudentsFilterData,
        };

        this.setState({ loadingSpinner: 1 })
        console.log("params", params);

        this.AddEducationalStudents(params).catch(error => {
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)[0],
                loadingSpinner: 0,
                currentStep: 1,
            });
            console.error(
                "ERR =>",
                error.graphQLErrors.map(x => x.message)[0]
            );
            // setTimeout(() => {
            //     this.props.onHide();
            //     window.location.reload(false);
            // }, 1500);
        });
    };

    AddEducationalStudents = async params => {
        console.log("child");
        await this.props.AddEducationalStudents({
            variables: {
                params
            },
            update: (store, { data }) => {
                console.log("dataaaaaaaaaaaaaa", data);
                if (data.AddEducationalStudents) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1500);
                }
            }
        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
    };

    articlecolumns = [
        {
            dataField: "student_name",
            text: "Student Name",
            sort: true,
        },
        {
            dataField: "student_roll_no",
            text: "Roll No",
            sort: true
        },
        {
            dataField: "student_mobile",
            text: "Mobile",
            sort: true,
        },
        {
            dataField: "parent_name",
            text: "Parent Name",
            sort: true,
        },
        {
            dataField: "parent_mobile",
            text: "Parent Mobile",
            sort: true,
        },
        {
            dataField: "parent_password",
            text: "Parent Password",
            sort: true,
        },
    ];

    render() {

        console.log("sections", this.state);
        console.log(" StudentsFilterData", this.state.StudentsFilterData);

        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Student</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Form>
                        <Form.Row>
                            <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                                <Form.Label className="text-uppercase">Branch</Form.Label>
                                <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch}>
                                    <option value={this.state.defaultvalue}>--Select Branch--</option>
                                    {this.props.globals.globalBranches.map(branchData => (
                                        <option value={branchData.id}>{branchData.branch_name}</option>
                                    ))}
                                </Form.Control>
                                <Form.Text className="form-text text-danger">
                                    {this.state.branchError}
                                </Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={2} md={12} sm={12} controlId="Selectexam">
                                <Form.Label className="text-uppercase">Exam</Form.Label>
                                <Form.Control as="select" name="exam" onChange={this.handleInputChange} value={this.state.exam}>
                                    <option value={this.state.defaultvalue}>--Select Exam--</option>
                                    {this.state.getExams.map(item => (
                                        <option value={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </Form.Control>
                                <Form.Text className="form-text text-danger">
                                    {this.state.examError}
                                </Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                                <Form.Label className="text-uppercase">Class</Form.Label>
                                <Form.Control as="select" name="class" onChange={this.handleInputChange} value={this.state.class}>
                                    <option value={this.state.defaultvalue}>--Select class--</option>
                                    {this.state.getClasses.map(classdata => (
                                        <option value={classdata.value}>{classdata.label}</option>
                                    ))}
                                </Form.Control>
                                <Form.Text className="form-text text-danger">
                                    {this.state.classError}
                                </Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectSection">
                                <Form.Label className="text-uppercase">Section</Form.Label>
                                <Form.Control as="select" name="section" onChange={this.handleInputChange} value={this.state.section}>
                                    <option value={this.state.defaultvalue}>--Select Section--</option>
                                    {this.state.getSections.map(sectiondata => (
                                        <option value={sectiondata.value}>
                                            {sectiondata.label}
                                        </option>)
                                    )}
                                </Form.Control>
                                <Form.Text className="form-text text-danger">
                                    {this.state.sectionError}
                                </Form.Text>
                            </Form.Group>

                            <Form.Group controlId="formFile" as={Col} lg={3} md={12} sm={12}>
                                <Form.Label className="h6"><a href={SampleExcel} download>Download sample file</a></Form.Label>
                                <Form.Control name="file" type="file" onChange={this.handleFileChange} >
                                </Form.Control>
                                <Form.Text className="form-text text-danger">
                                    {this.state.fileError}
                                </Form.Text>
                            </Form.Group>
                        </Form.Row>
                    </Form>
                </Modal.Body>

                {
                    this.state.branch && this.state.exam && this.state.class && this.state.section && this.state.StudentsFilterData.length > 0 ? (
                        <>
                            <Card>
                                <TableSearchwithStudentResult
                                    parentData={this.state.StudentsFilterData}
                                    particlecolumns={this.articlecolumns}
                                    defaultSorted={{ dataField: "contenttype", order: "desc" }}
                                />
                            </Card>

                            <Modal.Footer variant="white" className="px-4">
                                <Row>
                                    <Col as={Col} lg={3} md={12} sm={12} className="text-center">
                                        <button className='mr-4 addeEdit_btn' onClick={this.handleFormSubmit} disabled={this.state.isSubmitting} style={this.state.isSubmitting == true ? { cursor: "not-allowed" } : { cursor: "pointer" }}>
                                            {
                                                this.state.loadingSpinner == 1 ? (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                ) : ""
                                            }Submit</button>
                                        <div className='d-block'>
                                            {this.state.currentStep == 5 ? (
                                                <Form.Text className="form-text text-Success mb-2 " style={{ textAlign: "center" }}>
                                                    <p style={{ color: "green" }}>successfully Submitted</p>
                                                </Form.Text>
                                            ) : (
                                                <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center" }}>
                                                    {this.state.submitError}
                                                </Form.Text>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </Modal.Footer>
                        </>
                    ) : ("")
                }
            </Modal>
        );
    }
}
export default graphql(ADD_STUDENT, {
    name: "AddEducationalStudents"
})(StudentModal);
